import { Provider } from "./provider/Provider";

const OptionService = {
  optionList: ({ lang }) => {
    return Provider({
      lang,
      methodName: "Api/Option/OptionList",
    });
  },
  optionList_Type: ({ optionType, optionName, lang }) => {
    return Provider({
      optionName,
      optionType,
      lang,
      methodName: "Api/Option/OptionList",
    });
  },
  inputList: ({ optionSysName, lang }) => {
    return Provider({
      optionSysName,
      lang,
      methodName: "Api/Option/InputList",
    });
  },
  inputList_Type: ({ optionSysName, optionType, optionName, lang }) => {
    return Provider({
      optionType,
      optionName,
      optionSysName,
      lang,
      methodName: "Api/Option/InputList",
    });
  },
  option: ({ optionSysName, lang }) => {
    return Provider({
      optionSysName,
      lang,
      methodName: "Api/Option/Option",
    });
  },
  option_Type: ({ optionType, optionName, optionSysName, lang }) => {
    return Provider({
      optionType,
      optionName,
      optionSysName,
      lang,
      methodName: "Api/Option/Option",
    });
  },
  option_l: ({ optionCode }) => {
    return Provider({
      optionCode,
      methodName: "Api/Option/Option_l",
    });
  },
  option_l_Type: ({ optionType, optionName, optionCode }) => {
    return Provider({
      optionType,
      optionName,
      optionCode,
      methodName: "Api/Option/Option_l",
    });
  },
  updateInputList: ({ optionSysName, inputList }) => {
    return Provider({
      optionSysName: optionSysName,
      inputList: inputList,
      methodName: "Api/Option/UpdateInputList",
    });
  },
  updateInputList_Type: ({
    optionType,
    optionName,
    optionSysName,
    inputList,
  }) => {
    return Provider({
      optionType: optionType,
      optionName: optionName,
      optionSysName: optionSysName,
      inputList: inputList,
      methodName: "Api/Option/UpdateInputList",
    });
  },
  addOption: ({
    optionData,
    optionType,
    optionName,
    typeName,
    addOptionSysName,
  }) => {
    return Provider({
      _l: { ...optionData },
      optionType: optionType,
      optionName: optionName,
      typeName: typeName,
      addOptionSysName: addOptionSysName,
      methodName: "Api/Option/AddOption",
    });
  },
  addOption_Type: ({
    optionData,
    optionType,
    optionName,
    addOptionSysName,
    typeName,
  }) => {
    return Provider({
      _l: {
        ...optionData,
      },
      optionType,
      optionName,
      addOptionSysName,
      typeName,
      methodName: "Api/Option/AddOption",
    });
  },
  updateOption: ({
    optionData,
    updateOptionCode,
    updateOptionSysName,
    optionType,
    optionName,
  }) => {
    return Provider({
      _l: {
        ...optionData,
      },
      updateOptionCode,
      updateOptionSysName,
      optionType,
      optionName,
      methodName: "Api/Option/UpdateOption",
    });
  },
  updateOption_Type: ({
    optionData,
    optionType,
    optionName,
    updateOptionCode,
    updateOptionSysName,
  }) => {
    return Provider({
      _l: {
        ...optionData,
      },
      updateOptionCode,
      updateOptionSysName,
      optionType,
      optionName,
      methodName: "Api/Option/UpdateOption",
    });
  },
  deleteOption: ({ optionCode }) => {
    return Provider({
      optionCode,
      methodName: "Api/Option/DeleteOption",
    });
  },
  deleteOption_Type: ({ optionCode, optionType, optionName }) => {
    return Provider({
      optionCode,
      optionType,
      optionName,
      methodName: "Api/Option/DeleteOption",
    });
  },
  updateOptionsQueue: ({ optsList, optionType, optionName }) => {
    return Provider({
      optsList,
      optionType,
      optionName,
      methodName: "Api/Option/UpdateOptionsQueue",
    });
  },
  updateInputsQueue: ({ inputsList }) => {
    return Provider({
      inputsList,
      methodName: "Api/Option/UpdateInputsQueue",
    });
  },
  inputClasses: () => {
    return Provider({
      methodName: "Api/Option/InputClasses",
    });
  },
  addInput: ({
    inputType,
    inputName,
    inputValue,
    inputOption,
    inputMerge,
    inputClass,
    inputAttrs,
    _l,
  }) => {
    return Provider({
      _l,
      inputType,
      inputName,
      inputValue,
      inputOption,
      inputMerge,
      inputClass,
      inputAttrs,
      methodName: "Api/Option/AddInput",
    });
  },
  updateInput: ({
    inputCode,
    inputType,
    inputName,
    inputValue,
    inputOption,
    inputMerge,
    inputClass,
    inputAttrs,
    _l,
  }) => {
    return Provider({
      _l,
      inputCode,
      inputType,
      inputName,
      inputValue,
      inputOption,
      inputMerge,
      inputClass,
      inputAttrs,
      methodName: "Api/Option/UpdateInput",
    });
  },
  addInput_Type: ({
    optionName,
    optionType,
    inputType,
    inputName,
    inputValue,
    inputOption,
    inputMerge,
    inputClass,
    inputAttrs,
    inputLangData,
  }) => {
    return Provider({
      optionName,
      optionType,
      _l: {
        ...inputLangData,
      },
      inputType,
      inputName,
      inputValue,
      inputOption,
      inputMerge,
      inputClass,
      inputAttrs,
      methodName: "Api/Option/AddInput",
    });
  },
  deleteInput: ({ inputCode }) => {
    return Provider({
      inputCode,
      methodName: "Api/Option/DeleteInput",
    });
  },
  inputDetail: ({ inputCode }) => {
    return Provider({
      inputCode,
      methodName: "Api/Option/InputDetail",
    });
  },
  inputOptions: ({ inputCode }) => {
    return Provider({
      inputCode,
      methodName: "Api/Option/InputOptions",
    });
  },
  addInputOption: ({ inputCode, optValue, _l }) => {
    return Provider({
      inputCode,
      optValue,
      _l,
      methodName: "Api/Option/AddInputOption",
    });
  },
  updateInputOption: ({ optCode, inputCode, optValue, _l }) => {
    return Provider({
      optCode,
      inputCode,
      optValue,
      _l,
      methodName: "Api/Option/UpdateInputOption",
    });
  },
  deleteInputOption: ({ optCode }) => {
    return Provider({
      optCode,
      methodName: "Api/Option/DeleteInputOption",
    });
  },
  updateInputOptionsQueue: ({ optsList }) => {
    return Provider({
      optsList,
      methodName: "Api/Option/UpdateInputOptionsQueue",
    });
  },
  getListOption: ({ inputCode, optCode }) => {
    return Provider({
      inputCode,
      optCode,
      methodName: "Api/Option/GetListOption_l",
    });
  },
  getInput: ({ option, inputName }) => {
    return Provider({
      option,
      inputName,
      methodName: "Api/Option/GetInput",
    });
  },
};

export default OptionService;
